import { useCallback, useMemo } from 'react';

export default function useRiskFactorsHeaderActionsConfig({
    optimalPortfolioOptimizer,
    optimalPortfolioSummary,
    setOptimalPortfolioOptimizer,
    setOptimalPortfolioSummary,
    handleWhatIfPortfolioChangeSummary,
    listOfWhatIfPortfolios,
    fetchOptimizerPortfolios,
    setError,
    setShowPortfolioMetrics,
    clearOptimizedOverlay,
    unsavedOptimizerRun,
    setOptimizedRiskMetrics,
    refreshSavedOptimizedPortfolio,
    availableBetaSources,
    setOptimizedGroupRiskMetrics,
    setOptimalPortfolioSummaryLoaded,
    onBeforeSelectPortfolio,
    onWatchlistRestorationStaged,
    posSizingSyncStatus = null,
    posSizingFreshnessSummary = null,
    onSyncPosSizingDraft = null,
    posSizingSyncDisabled = false,
    posSizingSyncInProgress = false,
}) {
    const onSelectedOptimizedPortfolio = useCallback(() => {
        setOptimizedGroupRiskMetrics(null);
        setOptimalPortfolioSummaryLoaded(false);
    }, [
        setOptimalPortfolioSummaryLoaded,
        setOptimizedGroupRiskMetrics,
    ]);

    const riskFactorsHeaderActionsProps = useMemo(() => ({
        optimalPortfolioOptimizer,
        optimalPortfolioSummary,
        setOptimalPortfolioOptimizer,
        setOptimalPortfolioSummary,
        handleWhatIfPortfolioChange: handleWhatIfPortfolioChangeSummary,
        listOfWhatIfPortfolios,
        fetchOptimizerPortfolios,
        setErrorOptimization: setError,
        setShowPortfolioMetrics,
        clearOptimizedOverlay,
        unsavedOptimizerRun,
        setOptimizedCalculations: setOptimizedRiskMetrics,
        dropdownDisplayValue: optimalPortfolioSummary,
        refreshSavedOptimizedPortfolio,
        posSizingSyncStatus,
        posSizingFreshnessSummary,
        onSyncPosSizingDraft,
        posSizingSyncDisabled,
        posSizingSyncInProgress,
        availableBetaSources,
        onSelectedOptimizedPortfolio,
        onBeforeSelectPortfolio,
        onWatchlistRestorationStaged,
    }), [
        availableBetaSources,
        clearOptimizedOverlay,
        fetchOptimizerPortfolios,
        handleWhatIfPortfolioChangeSummary,
        listOfWhatIfPortfolios,
        onSelectedOptimizedPortfolio,
        onBeforeSelectPortfolio,
        onWatchlistRestorationStaged,
        onSyncPosSizingDraft,
        optimalPortfolioOptimizer,
        optimalPortfolioSummary,
        posSizingSyncStatus,
        posSizingFreshnessSummary,
        posSizingSyncDisabled,
        posSizingSyncInProgress,
        refreshSavedOptimizedPortfolio,
        setError,
        setOptimizedRiskMetrics,
        setOptimalPortfolioOptimizer,
        setOptimalPortfolioSummary,
        setShowPortfolioMetrics,
        unsavedOptimizerRun,
    ]);

    return {
        riskFactorsHeaderActionsProps,
    };
}
